import React from "react";
import ProgressMenu from "./ProgressMenu";
import PageActions from "./PageActions";
import { useIcon, IconButton } from "@SeemplicityDev/shared";

interface PagesControlsProps {
  currentPage: number;
  currentPageKey: string;
  getNextPage: () => void;
  getPreviousPage: () => void;
  gotoPage: (page: string) => void;
  displayMenu: boolean;
  onExit: () => void;
  onMute: () => void;
  isMuted: boolean;
  onDownload: () => void;
}

const PagesControls: React.FC<PagesControlsProps> = ({
  currentPage,
  currentPageKey,
  getNextPage,
  getPreviousPage,
  gotoPage,
  displayMenu,
  onExit,
  onMute,
  isMuted,
  onDownload,
}) => {
  const { getSvg } = useIcon("LIGHT");
  return (
    <div className={"pages-controls"}>
      <div className="top-section">
        <img
          className={"seem-logo"}
          src={getSvg("logo") as string}
          alt={"seemplicity logo"}
        />
        {displayMenu && (
          <ProgressMenu currentPageKey={currentPageKey} goToPage={gotoPage} />
        )}
        <PageActions
          onMute={onMute}
          onDownload={onDownload}
          onExit={onExit}
          isMuted={isMuted}
        />
      </div>
      <div className="buttons-container">
        <IconButton
          isIcon={"seem-icon-arrow-down"}
          className={"next-button"}
          wrapperClassName={"next-button-wrapper"}
          onClick={getNextPage}
          buttonStyle={"primary"}
          size={"large"}
        />
        <IconButton
          isIcon={"seem-icon-arrow-up"}
          className={"next-button"}
          wrapperClassName={"next-button-wrapper"}
          onClick={getPreviousPage}
          buttonStyle={"primary"}
          size={"large"}
        />
      </div>
    </div>
  );
};

export default PagesControls;
